import * as React from 'react';

export function useId(prefix?: string): string {
  const reactId = React.useId();
  const safe = reactId.replace(/:/g, '');
  return prefix ? `${prefix}-${safe}` : safe;
}
